import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment } from '@angular/router';
import {Store} from '@ngrx/store';
import {IAppState} from 'src/app/shared/shared.interface';
import {AuthTokenService} from './auth-token.service';
import {AllRoles} from './auth.roles';
import { LogNavigationService } from './logNavigation.service';

@Injectable({
  providedIn: 'root',
})
export class RouteGuard  {
  CurrentUser: any;
  HasMenuRole: any;
  HasSubMenuRole: any;
  HasSubRole: any;
  subMenuRole: any;
  rolePath: any;

  AllRoles: AllRoles = new AllRoles();

  authorized: boolean = false;
  authorizedSubMenu: boolean = false;
  manMenu: any;
  manMenuPath: any;
  subMenuPath: any;
  currentURL: string;
  subMenu: any;
  roleIncluded: boolean = false;
  currentMainRole: any;

  constructor(
    private router: Router,
    private authTokenService: AuthTokenService,
    private store: Store<IAppState>,
    private logNavigationService: LogNavigationService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const userRoles = this.authTokenService.getUserRoles();
    if (!userRoles) {
      return this.router.navigateByUrl('404');
    }

    try {
      this.CurrentUser = JSON.parse(userRoles);
    } catch {
      return this.router.navigateByUrl('404');
    }
    this.authorizedSubMenu = false;
    if (this.CurrentUser !== undefined) {
      this.HasMenuRole = this.CurrentUser.filter(
        (x: any) => x.menuTitle == route.data.roles[0]
      );

      this.CurrentUser.forEach((element: any) => {
        this.subMenuRole = element.subMenuList.filter(
          (x: any) => x.subMenuName == route.data.roles[0]
        );
        if (this.subMenuRole?.length > 0) {
          this.authorizedSubMenu = true;
          this.logNavigationService.LogNavigationActivities(this.subMenuRole[0]).subscribe(
            (response) => {
              // Handle response if needed
            },
            (error) => {
              // Handle error if needed
            }
          );
        }
        if (this.HasMenuRole.length === 0 && this.subMenuRole.length === 0) {
          if (this.currentMainRole !== element.menuTitle) {
            if (this.manMenuPath?.length === undefined || this.manMenuPath?.length === 0) {
              this.manMenuPath = this.AllRoles.roles.filter(
                (x: any) => x.role == element.menuTitle
              );
              this.subMenu = element.subMenuList[0].subMenuName;
              this.subMenuPath = this.AllRoles.roles.filter(
                (x: any) => x.role == this.subMenu
              );
            }
          }
        }
      });

      if (this.HasMenuRole?.length > 0) {
        this.authorized = true;
      } else if (this.subMenuRole?.length > 0) {
        this.authorized = true;
        this.authorizedSubMenu = true;
      } else {
        if (this.authorizedSubMenu) {
          this.authorized = true;
        } else {
          if (this.manMenuPath && this.manMenuPath.length > 0 && this.subMenuPath && this.subMenuPath.length > 0) {
            this.rolePath = this.manMenuPath[0].path + '/' + this.subMenuPath[0].path;
            this.manMenuPath = [];
            // this.currentMainRole = this.manMenuPath[0].role;
            return this.router.navigateByUrl(this.rolePath);
          } else {
            return this.router.navigateByUrl('404');
          }
        }
        // return this.router.navigateByUrl('404');
      }
    } else {
      return this.router.navigateByUrl('404');
    }

    return this.authorized;
  }

  canLoad(route: Route, segments: UrlSegment[]) {
    if (
      this.authTokenService.getValidAccessToken() ||
      this.authTokenService.getValidRefreshToken()
    ) {
      return true;
    }
    this.router.navigateByUrl('/login');
    return false;
  }
}
